import axios from '@/allotment/axios'
import store from '@/allotment/store'

export default {
  page: data => axios.post('/warn/select/page', data), //获取告警配置分页数据
  save: data => axios.post('/warn/save', data), //保存警配置
  status: data => axios.post('/warn/update/status', data), //修改告警配置状态

  delete: id => axios.get(`/device/warn/delete/${id}`), //删除告警
  count: () => axios.get(`/device/warn/count/${store.state.dataCenter.dataCenter || ''}`), //告警统计
  devicePage: data => axios.post('/device/warn/select/page', data), //日志警告管理列表
  stationPage: data => axios.post('/station/detail/warn', data), //电站日志警告列表

  list: () => axios.post('/device/warn/total/list', {}), //获取告警列表
  infoCount: id => axios.get(`/device/warn/detail/count/${id}`), // 告警详情统计
  infoPage: data => axios.post('/device/warn/detail/select/page', data), // 告警详情列表
  infoRemark: data => axios.post('/device/warn/detail/update/remark', data), // 告警详情备注
  infoExport: data => axios.post('/device/warn/detail/export', data, { notbody: true, responseType: 'blob', timeout: 10 * 60000 }) // 告警详情导出
}
